module.exports = __webpack_public_path__ + "3b6fbdac863502a665b50b1e54fd8929.jpg";


//////////////////
// WEBPACK FOOTER
// ./design/photos/schalen/Ruoff_091114_0032_w.jpg
// module id = 372
// module chunks = 0